import { useId } from 'react'
import './SimpleInput.scss'

export interface SimpleInputProps {
  label: string
  value?: string | number
  type?: string
  max?: number
  min?: number
  required?: boolean
  error?: boolean
  onBlur?: (value?: string | number) => void
  onInput?: (value: string | number) => void
}

const baseClass = 'simple-input'

const parseInputValue = (value: string, inputType: string): string | number => {
  if (inputType === 'number') {
    const num = parseFloat(value)
    return isNaN(num) ? value : num
  }
  return value
}

const SimpleInput = ({
  label,
  value,
  type = 'string',
  max,
  min,
  required = false,
  error = false,
  onBlur,
  onInput
}: SimpleInputProps) => {
  const id = useId()

  let inputClass = `${baseClass}__input`
  if (error) {
    inputClass = inputClass.concat(' error')
  }

  return (
    <div className={`${baseClass}__root`}>
      <label htmlFor={id} className={`${baseClass}__label`}>
        {label}
        {required && <span className='required'>*</span>}
      </label>
      <input
        className={inputClass}
        id={id}
        value={value}
        type={type}
        onInput={(e: React.FormEvent<HTMLInputElement>) => {
          if (onInput) {
            onInput(parseInputValue(e.currentTarget.value, type))
          }
        }}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
          if (onBlur) {
            onBlur(parseInputValue(e.currentTarget.value, type))
          }
        }}
        min={min}
        max={max}
      />
    </div>
  )
}

export default SimpleInput
